var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockpersontag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.5H13.5C13.7761 8.5 14 8.27614 14 8C14 7.72386 13.7761 7.5 13.5 7.5H2.5C2.22386 7.5 2 7.72386 2 8C2 8.27614 2.22386 8.5 2.5 8.5Z",
    fill: "#E11D48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.5H13.5C13.7761 10.5 14 10.2761 14 10C14 9.72386 13.7761 9.5 13.5 9.5H2.5C2.22386 9.5 2 9.72386 2 10C2 10.2761 2.22386 10.5 2.5 10.5Z",
    fill: "#E11D48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12.5H13.5C13.7761 12.5 14 12.2761 14 12C14 11.7239 13.7761 11.5 13.5 11.5H2.5C2.22386 11.5 2 11.7239 2 12C2 12.2761 2.22386 12.5 2.5 12.5Z",
    fill: "#E11D48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6.5C2 6.5 2 6.08579 2.29289 5.79289C2.29289 5.79289 2.58579 5.5 3 5.5H13C13 5.5 13.4142 5.5 13.7071 5.79289C13.7071 5.79289 14 6.08579 14 6.5V13.5C14 13.5 14 13.9142 13.7071 14.2071C13.7071 14.2071 13.4142 14.5 13 14.5H3C3 14.5 2.58579 14.5 2.29289 14.2071C2.29289 14.2071 2 13.9142 2 13.5V6.5ZM3 6.5V13.5L13 13.5V6.5H3Z",
    fill: "#E11D48"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 3.75V6C9.75 6.27614 9.97386 6.5 10.25 6.5C10.5261 6.5 10.75 6.27614 10.75 6V3.75C10.75 2.61091 9.94454 1.80546 9.94454 1.80546C9.13909 1 8 1 8 1C6.86091 1 6.05546 1.80546 6.05546 1.80546C5.25 2.61091 5.25 3.75 5.25 3.75V6C5.25 6.27614 5.47386 6.5 5.75 6.5C6.02614 6.5 6.25 6.27614 6.25 6V3.75C6.25 3.02513 6.76256 2.51256 6.76256 2.51256C7.27513 2 8 2 8 2C8.72487 2 9.23744 2.51256 9.23744 2.51256C9.75 3.02513 9.75 3.75 9.75 3.75Z",
    fill: "#E11D48"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockpersontag);
export default __webpack_public_path__ + "static/media/lockpersontag.916c6e929dea341e9ea1056a970eb800.svg";
export { ForwardRef as ReactComponent };